import React from 'react';
import classNames from 'classnames';

import { listItemPropTypes, reorderableListItem } from 'helpers/react_dnd/reorderable_list';

export class TableRow extends React.Component {
  static propTypes = listItemPropTypes;

  render() {
    const rowClass = classNames(
      this.props.className,
      { dragging: this.props.isDragging }
    );
    return this.props.connectDragPreview(this.props.connectDropTarget(this.props.connectDragSource(
      <tr className={rowClass}>
        {this.props.children}
      </tr>
    )));
  }
}

export default reorderableListItem(TableRow, 'tableRow', {
  canDrag: (() => true),

  beginDrag(props) {
    return {
      index: props.index,
      listName: props.listName
    };
  }
});
